export default __webpack_public_path__ + "static/media/logo.e3c0269e.svg";